import { Box, Flex, Heading } from '@chakra-ui/react'
import AnnouncementCard from './AnnouncementCard'
import { ANNOUNCEMENT_TYPES } from '@/features/announcements/announcement.constant'

const AnnouncementPage = () => {
  return (
    <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="300px" p="5">
      <Flex p={5} mb="3">
        <Heading> Announcement </Heading>
      </Flex>
      <Flex direction="column" gap="3">
        <AnnouncementCard type={ANNOUNCEMENT_TYPES.INTERNAL} />
        <AnnouncementCard type={ANNOUNCEMENT_TYPES.EXTERNAL} />
      </Flex>
    </Box>
  )
}

export default AnnouncementPage
